import { House, MapPin, Person, Storefront } from '@phosphor-icons/react'

import { deliveryMethodNames } from '@reveni-io/reveni-ui'

export const deliveryMethods = {
  customerpickup: { label: deliveryMethodNames.customerpickup, icon: <House size={24} weight="light" /> },
  pickuppoint: { label: deliveryMethodNames.pickuppoint, icon: <MapPin size={24} weight="light" /> },
  customerdelivers: { label: deliveryMethodNames.customerdelivers, icon: <Person size={24} weight="light" /> },
  returntostore: { label: deliveryMethodNames.returntostore, icon: <Storefront size={24} weight="light" /> },
}
